<template>
  <div v-if="watch_count != undefined">
  <h2 class="gradation">{{ watch_count }}人が最近注目しています</h2>
  <FundTile
    :fundId="fund_info.fund_id"
    :fundName="fund_info.fund_name"
    :explanationShort="fund_info.explanation_short"
    :thumbnailUri="thumbnail_style"
    :partner-name="fund_info.partner_name"
    :supporter="fund_info.supporter"
    :is-watch="fund_info.isWatched"
    :price = "price"
    :amount="fund_info.amount"
    :total-amount="fund_info.total_price"
  />
  </div>
</template>

<script>
import axios from 'axios'
import FundTile from './FundTile.vue'

export default {
  name: 'PopularWatchFund',
  components: {
    FundTile,
  },
  props: {
  },
  data() {
    return {
      fund_info: {},
      watch_count: 0,
      thumbnail_style: '',
      price: 0
    }
  },
  created: function () {
  },
  async mounted() {
    this.fetchContent()
  },
  methods: {
    async fetchContent() {
      const res = await axios.get('/api/watch/popular/fund').catch(() => {
        return;
      });

      this.fund_info = res.data;
      this.watch_count = res.data.watch_count;
      this.thumbnail_style = '/data/fund/'+res.data.fund_id+'/toplist.jpg';
      this.price = Number(res.data.price) + Number(res.data.fee) + Number(res.data.purchase) + Number(res.data.donation)

      console.log(res);
    },
  }
}
</script>